/**
 * §6 readable ball ownership — the single shared rule for the on-pitch direction
 * arrow (and the kick/power UI it gates with).
 *
 * The arrow shows ONLY when the CONTROLLED player actually owns the ball in live
 * play. Every "hide" case the directive lists reduces to this one rule:
 *   - loose ball / ball in flight → possessedBy !== controlledId
 *   - opponent has it / teammate has it → possessedBy !== controlledId
 *   - goalkeeper controls it → state is GoalkeeperControlled (not CONTROLLED)
 *   - restart hasn't assigned it / out of play → state is OutOfPlay
 * so a single derivation from WorldState covers them all. A CONTESTED ball (an
 * opponent challenging within range) is still owned by the controlled player, so
 * the arrow stays — you are still on the ball.
 *
 * Pure and shared: the Test Arena, a practice match and an online match all gate
 * the arrow through THIS function, so ownership reads identically everywhere.
 */
import {
  PossessionState,
  classifyPossessionState,
  type WorldState,
} from '@fg/shared/sim';

export function possessionArrowVisible(world: WorldState, controlledId: number): boolean {
  if (controlledId < 0) return false;
  if (world.ball.possessedBy !== controlledId) return false;
  const st = classifyPossessionState(world);
  return st === PossessionState.Controlled || st === PossessionState.Contested;
}
